import React, { Component } from "react";
import { objectTypes } from "../../../core/components/buttonpanel/interface/Ibuttons";

interface IMainSettingPanelPortraitComponent {
    data: {}
}
export const mainSettingPanelPortraitComponent: IMainSettingPanelPortraitComponent = {
    data: {
        "COMPONENTS": [
            {
                child: [
                    //  {
                    //      "name": "backgroundGraphicSettingPanel1",
                    //      "type": "Graphic",
                    //      "shape": "rectangle",
                    //      "layout": true,
                    //      "uimode": "mobile",
                    //      "visible": true,
                    //      "alpha": 1,
                    //      "color": "0x191919",
                    //      "x": 0,
                    //      "y": 0,
                    //      "width": 1080,
                    //      "height": 1920,
                    //
                    //  },
                    {
                        "name": "topBar2",
                        "image": "bet_base.png",
                        "type": objectTypes.Sprite,
                        // "layout": true,
                        "uimode": "mobile",
                        "visible": true,
                        "x": 0,
                        "y": 0,
                        "width": 1080,
                        "height": 650,
                    },
                    {
                        "name": "topBar1",
                        "image": "header_top.png",
                        "type": objectTypes.Sprite,
                        // "layout": true,
                        "uimode": "mobile",
                        "visible": true,
                        "x": 0,
                        "y": 144,
                        "width": 1080,
                        "height": 150,
                    },



                    {
                        "name": "backgroundGraphicSettingPanelPortrait",
                        "type": "Graphic",
                        "shape": "rectangle",
                        // "layout": true,
                        "uimode": "mobile",
                        "visible": true,
                        "alpha": 1,
                        "color": "0x000000",
                        "x": 0,
                        "y": 289,
                        "width": 1080,
                        "height": 1631,

                    },
                    //{
                    //    "name": "bottom_base",
                    //    "image": "bottom_base.png",
                    //    "type": objectTypes.Sprite,
                    //    "layout": true,
                    //    "uimode": "mobile",
                    //    "visible": true,
                    //    "x": 0,
                    //    "y": 200,
                    //    "width": 1080,
                    //    "height": 178,
                    //},

                    //  {
                    //      "name": "sideBar1",
                    //      "image": "land_side_bar.png",
                    //      "type": objectTypes.Sprite,
                    //      "layout": true,
                    //      "uimode": "mobile",
                    //      "visible": true,
                    //      "x": 1710,
                    //      "y": 0,
                    //      "width": 210,
                    //      "height": 1080,
                    //  },








                    {
                        "id": "buttonscontainer1",
                        "name": "buttonsPortraitcontainer",
                        "type": "Container",
                        "class": "",
                        "x": 1768,
                        "y": 135,
                        //  "layout": true,
                        "uimode": "mobile",
                        "filterTypes": [],
                        child: [
                            {
                                "id": "Button_M1",
                                "name": "btn_Portraitguide_white",
                                "type": objectTypes.Sprite,
                                "interactive": true,
                                //  "layout": true,
                                "uimode": "mobile",
                                "x": -1706,
                                "y": 33,
                                "width": 100,
                                "height": 92,
                                "text": "",
                                "visible": true,
                                "buttonMode": true,
                                "buttonState": {
                                    up: 'i_btn_up.png',
                                    out: 'i_btn_up.png',
                                    down: 'i_btn_up.png',
                                    disable: 'i_btn_up.png',
                                    enable: 'i_btn_up.png',
                                    hover: 'i_btn_up.png'
                                },
                                "hitareaVisible": false,
                                "shapeVisible": false,
                                "shape": {}
                            },
                            {
                                "id": "Button_M5",
                                "name": "btn_Portraitguide_yellow",
                                "type": objectTypes.Sprite,
                                "interactive": true,
                                //   "layout": true,
                                "uimode": "mobile",
                                "x": -1706,
                                "y": 33,
                                "width": 100,
                                "height": 92,
                                "text": "",
                                "visible": false,
                                "buttonMode": true,
                                "buttonState": {
                                    up: 'i_btn_over.png',
                                    out: 'i_btn_over.png',
                                    down: 'i_btn_over.png',
                                    disable: 'i_btn_over.png',
                                    enable: 'i_btn_over.png',
                                    hover: 'i_btn_over.png'
                                },
                                "hitareaVisible": false,
                                "shapeVisible": false,
                                "shape": {}
                            },

                            {
                                "id": "text_1",
                                "name": "btn_Portraitguide_text",
                                "type": "Text",
                                //  "layout": true,
                                "uimode": "mobile",
                                "x": -1220,
                                "y": -66,
                                "text": "menu-title_game-guide_main",
                                "anchor": [0.5, 0.5],
                                "visible": false,
                                width: 700,
                                "scaleToFit": true,
                                "textStyle": {
                                    fontFamily: 'Arial',
                                    fontSize: 76,
                                    fill: ['#FFFFFF'],
                                    align: "center",

                                },
                                "parentLayer": "specialAnimationLayer",
                            },



                            {
                                "id": "Button_M2",
                                "name": "btn_Portraitpaytable_white",
                                "type": objectTypes.Sprite,
                                "interactive": true,
                                // "layout": true,
                                "uimode": "mobile",
                                "x": -1494,
                                "y": 33,
                                "width": 100,
                                "height": 92,
                                "text": "",
                                "visible": true,
                                "buttonMode": true,
                                "buttonState": {
                                    up: 'paytable_btn_up.png',
                                    out: 'paytable_btn_up.png',
                                    down: 'paytable_btn_up.png',
                                    disable: 'paytable_btn_up.png',
                                    enable: 'paytable_btn_up.png',
                                    hover: 'paytable_btn_up.png'
                                },
                                "hitareaVisible": false,
                                "shapeVisible": false,
                                "shape": {}
                            },
                            {
                                "id": "Button_M6",
                                "name": "btn_Portraitpaytable_yellow",
                                "type": objectTypes.Sprite,
                                "interactive": true,
                                // "layout": true,
                                "uimode": "mobile",
                                "x": -1494,
                                "y": 33,
                                "width": 100,
                                "height": 92,
                                "text": "",
                                "visible": false,
                                "buttonMode": true,
                                "buttonState": {
                                    up: 'paytable_btn_over.png',
                                    out: 'paytable_btn_over.png',
                                    down: 'paytable_btn_over.png',
                                    disable: 'paytable_btn_over.png',
                                    enable: 'paytable_btn_over.png',
                                    hover: 'paytable_btn_over.png'
                                },
                                "hitareaVisible": false,
                                "shapeVisible": false,
                                "shape": {}
                            },

                            {
                                "id": "text_2",
                                "name": "btn_Portraitpaytable_text",
                                "type": "Text",
                                // "layout": true,
                                "uimode": "mobile",
                                "x": -1220,
                                "y": -61,
                                "text": "game-guide_control_heading_paytable",
                                "anchor": [0.5, 0.5],
                                "visible": false,
                                width: 700,
                                "scaleToFit": true,
                                "textStyle": {
                                    fontFamily: 'Arial',
                                    fontSize: 76,
                                    fill: ['#FFFFFF'],
                                    align: "center",

                                },
                                "parentLayer": "specialAnimationLayer",
                            },





                            {
                                "id": "Button_M3",
                                "name": "btn_Portraithistory_white",
                                "type": objectTypes.Sprite,
                                "interactive": true,
                                //   "layout": true,
                                "uimode": "mobile",
                                "x": -1289,
                                "y": 33,
                                "width": 100,
                                "height": 92,
                                "text": "",
                                "visible": true,
                                "buttonMode": true,
                                "buttonState": {

                                    up: 'history_btn_up.png',
                                    out: 'history_btn_up.png',
                                    down: 'history_btn_up.png',
                                    disable: 'history_btn_up.png',
                                    enable: 'history_btn_up.png',
                                    hover: 'history_btn_up.png'
                                },
                                "hitareaVisible": false,
                                "shapeVisible": false,
                                "shape": {}
                            },
                            {
                                "id": "Button_M7",
                                "name": "btn_Portraithistory_yellow",
                                "type": objectTypes.Sprite,
                                "interactive": true,
                                // "layout": true,
                                "uimode": "mobile",
                                "x": -1289,
                                "y": 33,
                                "width": 100,
                                "height": 92,
                                "text": "",
                                "visible": false,
                                "buttonMode": true,
                                "buttonState": {


                                    up: 'history_btn_over.png',
                                    out: 'history_btn_over.png',
                                    down: 'history_btn_over.png',
                                    disable: 'history_btn_over.png',
                                    enable: 'history_btn_over.png',
                                    hover: 'history_btn_over.png'
                                },
                                "hitareaVisible": false,
                                "shapeVisible": false,
                                "shape": {}
                            },
                            {
                                "id": "text_3",
                                "name": "btn_Portraithistory_text",
                                "type": "Text",
                                // "layout": true,
                                "uimode": "mobile",
                                "x": -1220,
                                "y": -61,
                                "text": "game-guide_control_heading_bet-history",
                                "anchor": [0.5, 0.5],
                                "visible": false,
                                width: 700,
                                "scaleToFit": true,
                                "textStyle": {
                                    fontFamily: 'Arial',
                                    fontSize: 76,
                                    fill: ['#FFFFFF'],
                                    align: "center",

                                },
                                "parentLayer": "specialAnimationLayer",
                            },





                            {
                                "id": "Button_M4",
                                "name": "btn_Portraitsetting_white",
                                "type": objectTypes.Sprite,
                                "interactive": true,
                                // "layout": true,
                                "uimode": "mobile",
                                "x": -1071,
                                "y": 33,
                                "width": 100,
                                "height": 92,
                                "text": "",
                                "visible": true,
                                "buttonMode": true,
                                "buttonState": {
                                    up: 'setting_btn_up.png',
                                    out: 'setting_btn_up.png',
                                    down: 'setting_btn_up.png',
                                    disable: 'setting_btn_up.png',
                                    enable: 'setting_btn_up.png',
                                    hover: 'setting_btn_up.png'



                                },
                                "hitareaVisible": false,
                                "shapeVisible": false,
                                "shape": {}
                            },

                            {
                                "id": "Button_M8",
                                "name": "btn_Portraitsetting_yellow",
                                "type": objectTypes.Sprite,
                                "interactive": true,
                                // "layout": true,
                                "uimode": "mobile",
                                "x": -1071,
                                "y": 33,
                                "width": 100,
                                "height": 92,
                                "text": "",
                                "visible": false,
                                "buttonMode": true,
                                "buttonState": {
                                    up: 'setting_btn_over.png',
                                    out: 'setting_btn_over.png',
                                    down: 'setting_btn_over.png',
                                    disable: 'setting_btn_over.png',
                                    enable: 'setting_btn_over.png',
                                    hover: 'setting_btn_over.png'

                                },
                                "hitareaVisible": false,
                                "shapeVisible": false,
                                "shape": {}
                            },
                            {
                                "id": "text_3",
                                "name": "btn_PortraitGeneral_text",
                                "type": "Text",
                                // "layout": true,
                                "uimode": "mobile",
                                "x": -1237,
                                "y": -61,
                                "text": "menu-title_settings_general",
                                "anchor": [0.5, 0.5],
                                "visible": false,
                                width: 700,
                                "scaleToFit": true,
                                "textStyle": {
                                    fontFamily: 'Arial',
                                    fontSize: 76,
                                    fill: ['#FFFFFF'],
                                    align: "center",

                                },
                                "parentLayer": "specialAnimationLayer",
                            },
                            //   {
                            //       "id": "text_4",
                            //       "name": "btn_Portraitsetting_text1_white",
                            //       "type": "Text",
                            //       "layout": true,
                            //       "uimode": "mobile",
                            //       "x": -1237,
                            //       "y": 197,
                            //       "text": "generalText",
                            //       "anchor": [0.5, 0.5],
                            //       "visible": false,
                            //       width: 700,
                            //       "scaleToFit": true,
                            //       "textStyle": {
                            //           fontFamily: 'Arial',
                            //           fontSize: 76,
                            //           fill: ['#FFFFFF'],
                            //           align: "center",

                            //       },
                            //       "parentLayer": "specialAnimationLayer",
                            //   },

                            //  {
                            //      "id": "text_5",
                            //      "name": "btn_setting_text2_white",
                            //      "type": "Text",
                            //      "layout": true,
                            //      "uimode": "mobile",
                            //      "x": -551,
                            //      "y": 97,
                            //      "text": "AutoplayText",
                            //      "anchor": [0.5, 0.5],
                            //      "visible": false,
                            //      width: 700,
                            //      "scaleToFit": true,
                            //      "textStyle": {
                            //          fontFamily: 'Arial',
                            //          fontSize: 76,
                            //          fill: ['#FFFFFF'],
                            //          align: "center",

                            //      },
                            //      "parentLayer": "specialAnimationLayer",
                            //  },


                            //  {
                            //      "id": "text_6",
                            //      "name": "btn_setting_text1_yellow",
                            //      "type": "Text",
                            //      "layout": true,
                            //      "uimode": "mobile",
                            //      "x": -1277,
                            //      "y": 97,
                            //      "text": "generalText",
                            //      "anchor": [0.5, 0.5],
                            //      "visible": false,
                            //      width: 700,
                            //      "scaleToFit": true,
                            //      "textStyle": {
                            //          fontFamily: 'Arial',
                            //          fontSize: 76,
                            //          fill: ['#ffc107'],
                            //          align: "center",
                            //      },
                            //      "parentLayer": "specialAnimationLayer",
                            //  },
                            //  {
                            //      "id": "text_7",
                            //      "name": "btn_setting_text2_yellow",
                            //      "type": "Text",
                            //      "layout": true,
                            //      "uimode": "mobile",
                            //      "x": -551,
                            //      "y": 97,
                            //      "text": "AutoplayText",
                            //      "anchor": [0.5, 0.5],
                            //      "visible": false,
                            //      width: 700,
                            //      "scaleToFit": true,
                            //      "textStyle": {
                            //          fontFamily: 'Arial',
                            //          fontSize: 76,
                            //          fill: ['#ffc107'],
                            //          align: "center",
                            //      },
                            //      "parentLayer": "specialAnimationLayer",
                            //  },

                            //    {
                            //        "name": "gameSettingsBtnMobile",
                            //        "type": "Graphic",
                            //        "shape": "rectangle",
                            //        "layout": true,
                            //        "uimode": "mobile",
                            //        "interactive": true,
                            //        "buttonMode": true,
                            //        "visible": true,
                            //        "alpha": 0.01,
                            //        "color": "0xffffff",
                            //        "x": -1419,
                            //        "y": 53,
                            //        "width": 300,
                            //        "height": 100,
                            //
                            //    },
                            //    {
                            //        "name": "autoplayBtnMobile",
                            //        "type": "Graphic",
                            //        "shape": "rectangle",
                            //        "layout": true,
                            //        "uimode": "mobile",
                            //        "interactive": true,
                            //        "buttonMode": true,
                            //        "visible": true,
                            //        "alpha": 0.01,
                            //        "color": "0xffffff",
                            //        "x": -701,
                            //        "y": 53,
                            //        "width": 300,
                            //        "height": 100,
                            //
                            //    },




                        ],


                    },


                    {
                        "id": "Button_M9",
                        "name": "settingPanelCloseButton_portrait",
                        "type": objectTypes.Sprite,
                        "interactive": true,
                        // "layout": true,
                        "uimode": "mobile",
                        "x": 911,
                        "y": 172,
                        "width": 100,
                        "height": 92,
                        "text": "",
                        "visible": true,
                        "buttonMode": true,
                        "buttonState": {
                            up: 'close_btn_up.png',
                            out: 'close_btn_up.png',
                            down: 'close_btn_up.png',
                            disable: 'close_btn_up.png',
                            enable: 'close_btn_up.png',
                            hover: 'close_btn_up.png'

                        },
                        "hitareaVisible": false,
                        "shapeVisible": false,
                        "shape": {}
                    },
                    {
                        "id": "Button_M10",
                        "name": "homeButton_portrait",
                        "image": "homeButton",
                        "type": "Image",
                        // "layout": true,
                        "buttonMode": true,
                        "interactive": true,
                        "uimode": "mobile",
                        "class": "",
                        "parentLayer": "specialAnimationLayer",
                        "anchor": [0.5, 0.5],
                        "visible": false,
                        "width": 100,
                        "height": 92,
                        "x": 964,
                        "y": 69,
                    },

                    // {
                    //     "name": "yellowLine",
                    //     "image": "land_header_text_highlight_line.png",
                    //     "type": objectTypes.Sprite,
                    //     "layout": true,
                    //     "uimode": "mobile",
                    //     "visible": true,
                    //     "x": 674,
                    //     "y": 177,
                    //     "width": 372,
                    //     "height": 3,
                    // },
                    {
                        "id": "GameGuideComponentPortrait",
                        "name": "GameGuideComponentPortrait",
                        "type": "Tag",
                        "class": "",
                        "visible": true,
                        "parentLayer": "specialAnimationLayer",
                        "filterTypes": [],
                        child: []
                    },



                    //    {
                    //        "id": "GameGeneralComponent",
                    //        "name": "GameGeneralComponent",
                    //        "type": "Tag",
                    //        "class": "",
                    //        "parentLayer": "specialAnimationLayer",
                    //        "filterTypes": [],
                    //        child: []
                    //    },


                    {
                        "id": "GameGeneralComponentPortrait",
                        "name": "GameGeneralComponentPortrait",
                        "type": "Tag",
                        "class": "",
                        "parentLayer": "specialAnimationLayer",
                        "filterTypes": [],
                        child: []
                    },

                    {
                        "id": "MobilePaytablePortrait",
                        "name": "MobilePaytablePortrait",
                        "type": "Tag",
                        "class": "",
                        "parentLayer": "specialAnimationLayer",
                        "filterTypes": [],
                        child: []
                    },

                    {
                        id: "gameName_label_bottom_portraitMenu",
                        "name": "gameName_label_bottom_portraitMenu",
                        "type": "Container",
                        "class": "",
                        "visible": true,
                        "messageInLoop": true,
                        //   "layout": true,
                        "uimode": "mobile",
                        "x": -10,
                        "y": 814,
                        "width": 0,
                        "height": 0,
                        "filterTypes": [],
                        child: [

                            {
                                "id": "gameName_label_bottom2",
                                "name": "gameName_label_bottom2",
                                "type": "Text",
                                "x": 942,
                                "y": 1063,
                                "width": 500,
                                "visible": true,
                                "text": "INCA IDOLS",
                                "scaleToFit": true,
                                "anchor": [0.5, 0.5],
                                "textStyle": {
                                    fontFamily: 'Oswald-SemiBold',
                                    fontSize: 20,
                                    fontStyle: 'normal',
                                    fill: ['#999999'],
                                },
                                "parentLayer": "specialAnimationLayer",
                            },

                            {
                                "id": "game_clock",
                                "name": "game_clock",
                                "type": "Text",
                                "x": 74,
                                "y": 1063,
                                "width": 300,
                                "visible": true,
                                "text": "10.41",
                                "scaleToFit": true,
                                "anchor": [0.5, 0.5],
                                "textStyle": {
                                    fontFamily: 'Oswald-SemiBold',
                                    fontSize: 20,
                                    fontStyle: 'normal',
                                    fill: ['#999999'],
                                },
                                "parentLayer": "specialAnimationLayer",
                            },
                            /*  {
                                 "name": "brand_icon",
                                 "image": "brand_icon.png",
                                 "type": "Image",
                                 "class": "",
                                 "layout": true,
                                 "uimode": "mobile",
                                 "visible": true,
                                 "width": 24,
                                 "height": 25,
                                 "x": 1062,
                                 "y": 1049
                             }, */


                        ]

                    },
                ]
            },

        ],
    }


};

export const MainSettingPanelPortraitComponentConfigurationContext = React.createContext(
    {}
);